module.exports = __webpack_public_path__ + "img/mottocenter-new-logo-blue.8f38a7d1.png";